import { render, staticRenderFns } from "./PassResetAlert.vue?vue&type=template&id=2e6e41b8&scoped=true&"
import script from "./PassResetAlert.vue?vue&type=script&lang=ts&"
export * from "./PassResetAlert.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2e6e41b8",
  null
  
)

export default component.exports